import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import { ExpressCheckoutState } from 'store/expressCheckout/types';

export const getExpressCheckoutState = (state: RootState): ExpressCheckoutState =>
  state?.expressCheckout;

export const getExpressCheckout = createSelector(
  [getExpressCheckoutState],
  (state: ExpressCheckoutState) => state?.data
);
